import { doc, setDoc, Timestamp, updateDoc } from 'firebase/firestore';

import { useAuth } from '../contextProviders/AuthProvider';
import { firestore } from '../firebase';
import GuidanceAction, { GUIDANCE_ACTION_STATUSES, GuidanceActionType } from '../types/GuidanceAction';

export const useGuidanceActionMutators = () => {
  const { isGod } = useAuth();

  const dismissGuidanceAction = async (profileId: string, actionId: string): Promise<void> => {
    if (!profileId || !actionId) {
      console.error('profileId and actionId are required to dismiss a guidance action');
      return;
    }
    try {
      await updateDoc(doc(firestore, 'profile', profileId, 'guidanceAction', actionId), {
        status: GUIDANCE_ACTION_STATUSES.FULFILLED,
      });
    } catch (error) {
      console.error('Error dismissing guidance action:', error);
    }
  };

  const createGuidanceActionForProfile = async (
    profileId: string,
    actionType: GuidanceActionType,
    context?: Record<string, string>,
    overrides?: { title?: string; description?: string },
  ): Promise<void> => {
    if (!isGod) {
      console.error('Only god users can create guidance actions from the client');
      return;
    }
    const contextKey = context?.teamId ?? context?.leagueId ?? 'default';
    const docId = `${actionType}_${contextKey}`;
    const docRef = doc(firestore, 'profile', profileId, 'guidanceAction', docId);
    const action: GuidanceAction = {
      actionType,
      ...(context && { context }),
      createTime: Timestamp.now(),
      creatorId: 'god',
      ...(overrides?.description && { description: overrides.description }),
      itemId: docId,
      profileId,
      status: GUIDANCE_ACTION_STATUSES.ACTIVE,
      ...(overrides?.title && { title: overrides.title }),
    };
    try {
      await setDoc(docRef, action);
    } catch (error) {
      console.error('Error creating guidance action:', error);
    }
  };

  return { dismissGuidanceAction, createGuidanceActionForProfile };
};
